module.exports = __webpack_public_path__ + "img/2.76439e96.png";